import type { TerrainMeta } from './types';

export class CoordTransform {
    readonly meta: TerrainMeta;
    readonly lonSpan: number;
    readonly latSpan: number;

    // Set by main.ts after loadTerrainData
    _terrainY: Float32Array | null = null;
    _segX = 0;
    _segZ = 0;
    exaggeration = 1;

    constructor(meta: TerrainMeta) {
        this.meta    = meta;
        this.lonSpan = meta.bounds.maxLon - meta.bounds.minLon;
        this.latSpan = meta.bounds.maxLat - meta.bounds.minLat;
    }

    geoToWorld(lon: number, lat: number): { x: number; z: number } {
        const x = ((lon - this.meta.bounds.minLon) / this.lonSpan - 0.5) * this.meta.world.width;
        const z = (0.5 - (lat - this.meta.bounds.minLat) / this.latSpan) * this.meta.world.height;
        return { x, z };
    }

    sampleTerrainY(lon: number, lat: number): number {
        if (!this._terrainY) return 0;
        const u  = (lon - this.meta.bounds.minLon) / this.lonSpan;
        const v  = 1.0 - (lat - this.meta.bounds.minLat) / this.latSpan;
        const ix = Math.max(0, Math.min(this._segX, Math.round(u * this._segX)));
        const iz = Math.max(0, Math.min(this._segZ, Math.round(v * this._segZ)));
        return this._terrainY[iz * (this._segX + 1) + ix] * this.exaggeration;
    }
}
